import styled from 'styled-components';
import { mix, rgba } from 'polished';
import { combineValues, globalTheme } from '@clds/component-theme';
import focusCss from '../helpers/focusCss';
import { withTooltip } from '../helpers/withTooltip';
import { sliderTheme } from '../sliderTheme';
import { SliderProps } from '../props';

const Handler = styled.button<Omit<SliderProps, 'value'> & { value: string }>`
  width: ${sliderTheme.normal.handler.width};
  height: ${sliderTheme.normal.handler.height};
  padding: 0;
  border-radius: ${sliderTheme.normal.handler.border.radius};
  border: 2px solid ${globalTheme.palette.primary};
  background-color: ${globalTheme.palette.surfaceAlt};
  outline: none;
  transition: background-color 250ms, border 250ms;
  cursor: grab;

  ${focusCss};

  &:active {
    color: ${combineValues(globalTheme.palette.contrastInvert, (color) => rgba(color, 0.5))};
    background-color: ${combineValues(globalTheme.palette.contrastInvert, globalTheme.palette.primary, (overlay, color) =>
      mix(0.12, overlay, color)
    )};

    border-color: ${combineValues(globalTheme.palette.contrastInvert, globalTheme.palette.primary, (overlay, color) => mix(0.12, overlay, color))};
  }
  
  &:disabled {
    cursor: default;
    border-color: ${globalTheme.palette.secondary};
  }
`;

export default withTooltip(Handler);
